<template>
    <rkm-layout-body title="Lista de unidades executantes">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-unidade-executante-manutencao-create' })"
                color="primary"
                authorize="store-cadastro-unidade-executante-manutencao"
            >
                Cadastrar unidade executante
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/unidade-executante-manutencao/List'

export default {
    components: { List },
}
</script>